import ApiService from './ApiService'

export async function apiGetTicketOverview(data) {
    return ApiService.fetchData({
        url: '/ticket/details',
        method: 'post',
        data,
    })
}

export async function apiGetTicketDetails(data) {
    return ApiService.fetchData({
        url: '/ticket/summarize',
        method: 'post',
        data,
    })
}

export async function apiRunClosureCheck(data) {
    return ApiService.fetchData({
        url: '/ticket/closure-check',
        method: 'post',
        data,
    })
}

export async function apiSearchOpenTickets(data) {
    return ApiService.fetchData({
        url: '/ticket/open-search',
        method: 'post',
        data,
    })
}

export async function apiGetRecentlyOpenedTickets(data) {
    return ApiService.fetchData({
        url: '/ticket/recently-opened',
        method: 'post',
        data,
    })
}